module.exports = __webpack_public_path__ + "93df7c3ce947349fad13ba2aa2963998.svg";